import { render, staticRenderFns } from "./QuotationTemplateTable.vue?vue&type=template&id=321edf42&scoped=true&lang=html"
import script from "./QuotationTemplateTable.vue?vue&type=script&lang=js"
export * from "./QuotationTemplateTable.vue?vue&type=script&lang=js"
import style0 from "./QuotationTemplateTable.vue?vue&type=style&index=0&id=321edf42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321edf42",
  null
  
)

export default component.exports